module.exports = __webpack_public_path__ + "static/logo-s-d865134e6dcab495907e7d2aa2fe5d21.svg";